export enum Modules {
    Aktionsslider = 'aktionsslider',
    ConfigListing = 'configListing',
    ErweiterteSchnellsuche = 'erweiterteSchnellsuche',
    Fahrzeugliste = 'fahrzeugliste',
    Fahrzeugslider = 'fahrzeugslider',
    Fahrzeugsuche = 'fahrzeugsuche',
    Finanzierungsansicht = 'finanzierungsansicht',
    Install = 'install',
    Menu = 'menu',
    Print = 'print',
    Schnellsuche = 'schnellsuche',
    Standorte = 'standorte',
}

export type ModulesContainer =
    | 'ahdFahrzeugsuche'
    | 'ahdFahrzeugliste'
    | 'ahdSchnellsuche'
    | 'ahdErweiterteSchnellsuche'
    | 'ahdAktion'
    | 'ahdFinanzierung'
    | 'ahdInstallDocumentationSite'
    | 'ahdMenu'
    | 'ahdPrint'
    | 'ahdConfigListing'
    | 'ahdFahrzeugslider'
    | 'ahdStandorte';

export enum SourceList {
    Aktionsslider = 2,
    Contact = 8,
    ErweiterteSchnellsuche = 3,
    Fahrzeugliste = 7,
    Fahrzeugslider = 4,
    Fahrzeugsuche = 0,
    Finanzierungsansicht = 5,
    Schnellsuche = 6,
    SimilarList = 1,
    Standorte = 9,
}
